<template>
  <v-btn :color="nativeShare ? 'primary' : '#4267B2'" :href="facebookShareUrl" @click="share" target="_blank" dark>
    <v-icon class="mr-1" v-if="nativeShare">mdi-share-variant</v-icon>
    <v-icon class="mr-1" v-if="!nativeShare">mdi-facebook</v-icon>
    <span>{{ $t("live.activity.selfie.share") }}</span>
  </v-btn>
</template>

<script>
export default {
  props: {
    selfie: {
      type: Object,
    },
  },
  data() {
    return {
      nativeShare: !!navigator.share,
    };
  },
  methods: {
    share(event) {
      if (navigator.share) {
        event.preventDefault();
        navigator
          .share({
            title: `${this.$store.state.participantUsername} @ ${this.$store.state.selectedActivity.name}`,
            text:
              (this.$store.state.challengePerformance || this.selfie.step) +
              (this.$store.state.activityTeam
                ? `  #${this.$store.state.activityTeam.name.replace(/[^a-z0-9]/gi, "")}`
                : ""),
            url: `https://${location.hostname}/api/event/${this.$store.state.selectedActivity.id}/selfies/${this.selfie.id}.html`,
          })
          .then(() => this.$emit("done"))
          .catch((error) => console.log("Sharing failed", error));
        return false;
      }
      setImmediate(() => this.$emit("done"));
    },
  },
  computed: {
    facebookShareUrl() {
      return `https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2F${location.hostname}%2Fapi%2Fevent%2F${this.$store.state.selectedActivity.id}%2Fselfies%2F${this.selfie.id}.html`;
    },
  },
};
</script>

<style scoped></style>
